import React from "react";
import ImageUploader from "storybookComponents/ImageUploader";
import environment from "environments/environment"
import { getPropertyId } from "common"
import { getAssetCategoryId } from "relay/event"

const tabs = [
  {
    long_text: "Upload",
    short_text: "Upload"
  },
  {
    long_text: "Property Images",
    short_text: "Property"
  },
  {
    long_text: "Org Images",
    short_text: "Org"
  },
  {
    long_text: "Floor Plan",
    short_text: "Floor"
  }
];


const ImageChanger = ({ onChange, customButton, showNotification, onRef, ...rest }) => {

  const [assetCategory, setAssetCategory] = React.useState();

  React.useEffect(() => {
    getAssetCategoryId(getPropertyId(), "suborg_asset").then(id => {
      setAssetCategory(id)
    })
  }, [1])

  return (
    <ImageUploader
      ref={onRef}
      categoryId={assetCategory}
      propertyId={getPropertyId()}
      environment={environment}
      handleNotification={showNotification}
      customButton={customButton}
      fieldField={1}
      tabs={tabs}
      onUploadFinish={onChange}
      {...rest}
    />
  )
}


export default React.memo(ImageChanger);